import styled from 'styled-components'
import { svgStroke } from 'utilities/styled'
import Modal from 'modals/dialog'

export const ModalBody = styled(Modal.Body)`
    emoji-picker {
        --num-columns: 7;

        width: 100%;
    }
`

export const pickerShadowStyles = `
    .picker {
        background: none;
        border: 1px solid var(--huma-color-border-default);
        border-radius: 4px;
        overflow: clip;
        overflow-clip-margin: 4px;
    }

    .pad-top {
        display: none;
    }

    .search-row {
        order: 2;
        padding: 8px;
    }

    ${'' /*'components/form/input/text'*/}
    .search-row input {
        width: 100%;
        height: 40px;
        padding: 0 12px;
        position: relative;
        font-family: var(--huma-font-sans);
        font-size: 16px;
        line-height: 40px;
        color: var(--huma-color-foreground-default);
        background: none;
        border: 1px solid var(--huma-color-border-default);
        border-radius: 4px;
        transition: border-color .1s ease-in-out, box-shadow .1s ease-in-out;
        -webkit-appearance: none;
    }

    .search-row input::selection {
        background-color: var(--huma-color-border-constructive-focus);
    }

    .search-row input::placeholder {
        overflow: visible;
        color: var(--huma-color-foreground-minimal);
    }

    .search-row input:hover {
        border-color: var(--huma-color-border-default-focus);
    }

    .search-row input:focus {
        border-color: var(--huma-color-border-default);
        outline: none;
        box-shadow:
            0 0 0 1px var(--huma-color-surface-default),
            0 0 0 3px var(--huma-color-border-constructive-focus);

        ::selection {
            background-color: var(--huma-color-border-constructive-focus);
        }
    }

    .search-row input::-webkit-search-decoration,
    .search-row input::-webkit-search-cancel-button,
    .search-row input::-webkit-search-results-button,
    .search-row input::-webkit-search-results-decoration {
        -webkit-appearance: none;
    }

    .search-row > :not(.search-wrapper) {
        display: none;
    }

    .nav {
        order: 1;
        padding-block-end: 2px;
    }

    .nav::before {
        content: "";
        display: block;
        width: 100%;
        height: 2px;
        position: absolute;
        inset-block-end: 0;
        background: var(--huma-color-border-default);
    }

    .nav button.nav-button {
        display: grid;
        place-items: center;
        height: 40px;
        position: relative;
        color: var(--huma-color-foreground-subtle);
        cursor: pointer;
        transition: color .1s ease-out;

        ${svgStroke('small')}
    }

    .nav button.nav-button::before {
        content: "";
        display: block;
        width: 100%;
        height: 2px;
        position: absolute;
        inset-block-start: 100%;
        background-color: transparent;
        transition: background-color .1s ease-out;
    }

    .nav button.nav-button:where(:hover, :focus-visible, [aria-selected="true"]) {
        color: var(--huma-color-foreground-default);
        outline: none;
    }

    .nav button.nav-button:where(:hover, :focus-visible, [aria-selected="true"])::before {
        background-color: var(--huma-color-foreground-default);
    }

    .nav button.nav-button:where(:hover, :focus-visible, [aria-selected="true"]) .nav-emoji:hover {
        background: none;
    }

    .indicator-wrapper {
        display: none;
    }

    .tabpanel {
        order: 3;
        padding-block: 0 8px;
    }

    .emoji-menu {
        gap: 0;
    }

    .emoji-menu button.emoji {
        width: 40px;
        height: 40px;
        padding: 8px;
        position: relative;
        font-family: "Windows Chromium Flag Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "Android Emoji";
        font-size: 24px;
        line-height: 1.15;
    }

    .emoji-menu button.emoji:is(:hover, :focus-visible) {
        background: none;
        outline: none;
    }

    .emoji-menu button.emoji:is(:hover, :focus-visible)::before {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        inset: 0;
        z-index: -1;
        background-color: var(--huma-color-surface-minimal);
        border-radius: 100%;
    }

    .favorites {
        order: 4;
        padding-block: 4px;
        border-block-start: 1px solid var(--huma-color-border-default);
    }
`